import { render, staticRenderFns } from "./widget-stat-chart.vue?vue&type=template&id=65017614&scoped=true&"
import script from "./widget-stat-chart.vue?vue&type=script&lang=js&"
export * from "./widget-stat-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65017614",
  null
  
)

export default component.exports